import _ from 'lodash';
import { fork, put, take, takeLatest } from 'redux-saga/effects';
import { putAndWaitAPI, selectAPI } from '../../../api/API.sagas';
import {
    API_GET_CUSTOMER_STATE_EDIT,
    API_POST_ONFIDO_SMS,
    API_POST_ONFIDO_SMS_FAIL,
    API_POST_ONFIDO_SMS_SUCCESS,
    API_SAVE_CUSTOMER_STATE,
    API_SAVE_CUSTOMER_STATE_SUCCESS,
    API_GET_FUNDING_REQUIREMENT_SUCCESS
} from '../../../api/lendingAPI/LendingAPI.actions';
import { OPEN_MODAL } from '../../../iwModals/Modals.actions';
import {
    ACTIVATE_ONFIDO_VERIFICATION,
    ADD_PHONE_NUMBER,
    ONFIDO_VERIFICATION_DATA,
    ONFIDO_MAXIMUM_ATTEMPTS,
    PHONE_NUMBER_VALIDATION_ERROR,
    SEND_VERIFICATION_SMS,
    SEND_VERIFICATION_SMS_FAIL,
    SEND_VERIFICATION_SMS_PENDING,
    SEND_VERIFICATION_SMS_SUCCESS,
    TOGGLE_ADD_PHONE_NUMBER
} from './OnfidoVerificationModal.actions';
import {
    buildOnfidoMessagesSent,
    isValid,
    serialisePersonState
} from './OnfidoVerificationModalHelper';
import { getFundingRequirements } from '../../funding/fundingSteps/FundingSteps.sagas';

export const onfidoVerificationWorkers = [
    fork(onfidoVerificationWorker),
    fork(sendSMSWorker),
    fork(addPhoneNumberWorker)
];

function* onfidoVerificationWorker() {
    yield takeLatest(ACTIVATE_ONFIDO_VERIFICATION, function* () {
        yield put({ type: OPEN_MODAL, id: 'OnfidoVerificationModal' });

        const { customer_state, funding_requirement } = yield selectAPI();
        yield put({
            type: ONFIDO_VERIFICATION_DATA,
            customer_state,
            funding_requirement
        });
    });
}

function* sendSMSWorker() {
    yield takeLatest(SEND_VERIFICATION_SMS, function* (action) {
        yield put({
            type: SEND_VERIFICATION_SMS_PENDING,
            personUID: action.person.uid
        });
        const phoneEntry = _.find(action.person.phones, {
            value: action.phoneNumber
        });
        const data = {
            data: {
                person_uid: action.person.uid,
                phone_uid: phoneEntry.uid
            }
        };
        const { customer_state } = yield selectAPI();
        const previousOnfidoSMSMessagesSent =
            customer_state?.ui?.draw_down?.sms_verification_messages_sent;
        const nextAction = yield putAndWaitAPI({
            type: API_POST_ONFIDO_SMS,
            body: JSON.stringify(data)
        });
        switch (nextAction.type) {
            case API_POST_ONFIDO_SMS_SUCCESS:
                yield put({
                    type: 'api/UPDATE_DRAW_DOWN_STATE',
                    smsVerificationMessagesSent: buildOnfidoMessagesSent(
                        previousOnfidoSMSMessagesSent,
                        action.person.uid
                    )
                });
                yield take(API_SAVE_CUSTOMER_STATE_SUCCESS);
                yield put({
                    type: SEND_VERIFICATION_SMS_SUCCESS,
                    personUID: action.person.uid
                });

                yield* getFundingRequirements();

                const { response } = yield take(
                    API_GET_FUNDING_REQUIREMENT_SUCCESS
                );

                if (response.status === 400) {
                    yield put({
                        type: ONFIDO_MAXIMUM_ATTEMPTS,
                        personUID: action.person.uid
                    });
                    break;
                }

                const { customer_state, funding_requirement } =
                    yield selectAPI();

                yield put({
                    type: ONFIDO_VERIFICATION_DATA,
                    customer_state,
                    funding_requirement
                });
                break;

            case API_POST_ONFIDO_SMS_FAIL:
                yield put({
                    type: SEND_VERIFICATION_SMS_FAIL,
                    personUID: action.person.uid
                });
                break;
        }
    });
}

function* addPhoneNumberWorker() {
    yield takeLatest(ADD_PHONE_NUMBER, function* (action) {
        if (!isValid(action.person.newPhoneNumber)) {
            return yield put({
                type: PHONE_NUMBER_VALIDATION_ERROR,
                personUID: action.person.uid
            });
        }

        const { customer_state } = yield selectAPI();
        const people = customer_state?.application?.people;
        const newPersonState = serialisePersonState(people, action.person);
        yield saveFormAndClose(action.person.uid, newPersonState);
    });
}

function* saveFormAndClose(personUID, people) {
    yield put({
        type: API_GET_CUSTOMER_STATE_EDIT,
        data: {
            application: {
                people: people
            }
        }
    });

    yield put({ type: API_SAVE_CUSTOMER_STATE });
    yield take(API_SAVE_CUSTOMER_STATE_SUCCESS);

    const { customer_state, funding_requirement } = yield selectAPI();
    yield put({ type: TOGGLE_ADD_PHONE_NUMBER, personUID });
    yield put({
        type: ONFIDO_VERIFICATION_DATA,
        customer_state,
        funding_requirement
    });
}
